import FileItem from 'components/CreateEmailModal/components/FileItem/FileItem';

export default FileItem;
